import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';

import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { TermsComponent } from './terms/terms.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/material.module';
import { SinglePageRoutes } from './singlepage.routing.module';
import { PrivacyComponent } from './privacy/privacy.component';
import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    TermsComponent, PrivacyComponent, ContactComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    RouterModule.forChild(SinglePageRoutes),
    TablerIconsModule.pick(TablerIcons),
    SharedModule,
  ],
  exports: [TablerIconsModule],
})
export class SinglePageModule { }
